var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enterprise)?_c('div',{staticClass:"main-totem",style:({ 
    '--background-color': _vm.bgColor ? ("#" + _vm.bgColor): 'transparent',
    '--background': _vm.bgColor ? 'auto': 'none',
  })},[_c('main-content',{attrs:{"enterprise":_vm.enterprise}}),_c('main-menu'),(!_vm.isTotemAccessibility)?_c('meteo-language'):_vm._e(),_c('sidebar'),(!_vm.isTotemAccessibility)?_c('accessibility'):_c('meteo-language')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }